export const ACCOUNT_SECTIONS = [
  { id: 'overview', path: '', labelKey: 'account.nav.overview' },
  { id: 'profile', path: 'profile', labelKey: 'account.nav.profile' },
  { id: 'verification', path: 'verification', labelKey: 'account.nav.verification' },
  { id: 'cashier', path: 'payments', labelKey: 'account.nav.cashier' },
  { id: 'bets', path: 'bets', labelKey: 'account.nav.bets' },
  { id: 'bonuses', path: 'bonuses', labelKey: 'account.nav.bonuses' },
  { id: 'notifications', path: 'notifications', labelKey: 'account.nav.notifications' },
  { id: 'security', path: 'security', labelKey: 'account.nav.security' },
  { id: 'support', path: 'support', labelKey: 'account.nav.support' },
];

/** Path aliases → section id (CTA / legacy URLs). */
const PATH_ALIASES = {
  '': 'profile',
  overview: 'profile',
  summary: 'profile',
  deposit: 'cashier',
  withdraw: 'cashier',
  withdrawal: 'cashier',
  cashier: 'cashier',
  payments: 'cashier',
};

export function accountSectionFromPath(pathname) {
  if (!pathname.startsWith('/account')) return 'profile';
  const part = pathname.slice('/account'.length).replace(/^\//, '').split('/')[0] || '';
  if (Object.prototype.hasOwnProperty.call(PATH_ALIASES, part)) {
    return PATH_ALIASES[part];
  }
  return ACCOUNT_SECTIONS.find((s) => s.path === part)?.id || 'profile';
}

export function accountPathForSection(sectionId) {
  const id = sectionId === 'overview' ? 'profile' : sectionId;
  const section = ACCOUNT_SECTIONS.find((s) => s.id === id) || ACCOUNT_SECTIONS.find((s) => s.id === 'profile');
  return section.path ? `/account/${section.path}` : '/account/profile';
}
